export const initialAvailableStaysState = {
  status: 'idle',
  results: [],
  count: 0,
  totalPages: 1,
  error: null,
};

export const createAvailableStaysLoader = ({ request, onStateChange }) => {
  let sequence = 0;
  let active = null;
  let disposed = false;

  const load = ({ search, page }, { force = false } = {}) => {
    const key = `${String(search ?? '').trim()}|${page}`;
    if (!force && active?.key === key) return active.promise;

    sequence += 1;
    const requestSequence = sequence;
    active?.controller.abort();
    const controller = new AbortController();
    onStateChange({ ...initialAvailableStaysState, status: 'loading' });

    const promise = request({ search, page, signal: controller.signal })
      .then((payload) => {
        if (disposed || controller.signal.aborted || requestSequence !== sequence) return null;
        const nextState = {
          status: 'success',
          results: Array.isArray(payload?.results) ? payload.results : [],
          count: Number(payload?.count) || 0,
          totalPages: Math.max(1, Number(payload?.total_pages) || 1),
          error: null,
        };
        onStateChange(nextState);
        return nextState;
      })
      .catch((error) => {
        if (disposed || controller.signal.aborted || requestSequence !== sequence) return null;
        const nextState = { ...initialAvailableStaysState, status: 'error', error };
        onStateChange(nextState);
        return nextState;
      })
      .finally(() => {
        if (active?.promise === promise) active = null;
      });

    active = { key, controller, promise };
    return promise;
  };

  return {
    load,
    dispose: () => {
      disposed = true;
      sequence += 1;
      active?.controller.abort();
      active = null;
    },
  };
};
